import { dataPlusSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPlusSolid = /*#__PURE__*/createIcon(dataPlusSolid)
export default IconPlusSolid
